export const PREFIX = 'COMPANY_ART_FOLDER_';
export const RESET_LOGOS_PAGINATION = `${PREFIX}RESET_LOGOS_PAGINATION`;
export const resetLogosPaginationAction = perPage => ({
  type: RESET_LOGOS_PAGINATION,
  payload: {
    perPage
  }
});